export default "__VITE_ASSET__3e8ca7c6__"